import React, { useEffect } from 'react';

export default function KuulaProject(props) {

	useEffect(() => {
		// console.log('window', window)
	}, []);

	return (
		<div>
			<iframe className="ku-embed" 
				title="Travie McCoy"
				frameBorder="0" allowFullScreen allow="xr-spatial-tracking; gyroscope; accelerometer" scrolling="no" 
				src="https://kuula.co/share/collection/7vnTY?logo=-1&info=0&fs=1&vr=1&thumbs=-1&margin=5&inst=0"></iframe>
    	</div>
	)
}
